import useAutoScaleToFitContainer from 'hooks/useAutoScaleToFitContainer';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const withAutoScaleToFit = (Component) => {
  const AutoScaleToFitComponent = (props) => {
    const [width, setWidth] = useState(0);

    const {
      id,
      alignHorizontal = 'left',
      fitWidth = '100%',
      fitHeight = '100%',
    } = props || {};
    const className = `auto-scale-to-fit-class-${id}`;

    useEffect(() => {
      if (!id) return;
      const ele = document.getElementsByClassName(className)[0];
      if (ele) {
        setWidth(ele.offsetWidth);
      }
    }, [id, className]);

    useAutoScaleToFitContainer({
      className,
      alignHorizontal,
      ...(width && { maxWidth: width }),
    });

    const newProps = {
      ...props,
    };
    return (
      <ScaleTextContainer
        $fitWidth={fitWidth}
        $fitHeight={fitHeight}
        $alignHorizontal={alignHorizontal}
      >
        <Component {...newProps} className={className} />
      </ScaleTextContainer>
    );
  };
  return AutoScaleToFitComponent;
};

const ScaleTextContainer = styled.div`
  display: flex;
  justify-content: ${(props) => props.$alignHorizontal || 'center'};
  align-items: center;
  width: ${(props) => props.$fitWidth};
  height: ${(props) => props.$fitHeight};
`;

export default withAutoScaleToFit;
